import { PortionCount } from '@mindfulchefuk/config/portionCountConfig'
import plural from './plural'

type TQuantityAndPortionCopy = {
  showPortionAndQuantity: boolean
  quantity: number
  portionCount: PortionCount
}

export const quantityAndPortionCopy = ({
  showPortionAndQuantity,
  quantity,
  portionCount,
}: TQuantityAndPortionCopy) => {
  return showPortionAndQuantity && portionCount
    ? `${quantity} ${plural('meal')(
        quantity
      )} for ${portionCount}`.toUpperCase()
    : quantity
}
